export enum EStorageNames {
  filters = 'filters',
  table_collapsed = 'table_collapsed',
  mobile_filters = 'mobile_filters',
  tableSettings = 'tableSettings',
  cleanUpStorage_V1 = 'cleanUpStorage_V1',
}

type TStorage = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getItem: (key: EStorageNames) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setItem: (key: EStorageNames, value: any) => void;
  removeItem: (key: EStorageNames) => void;
  clear: () => void;
};

const appSessionStorage: TStorage = {
  getItem: key => {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  },
  setItem: (key, value) => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  },
  removeItem: key => {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  },
  clear: () => {
    try {
      sessionStorage.clear();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  },
};
const appLocalStorage: TStorage = {
  getItem: key => {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  },
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  },
  removeItem: key => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  },
  clear: () => {
    try {
      localStorage.clear();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  },
};

export { appLocalStorage, appSessionStorage };
